/**
 * Copyright 2026 Google LLC.
 * Copyright (c) Microsoft Corporation.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * THIS FILE IS AUTOGENERATED by cddlconv 0.2.0.
 * Run `tools/update_bidi_types.py` to regenerate.
 * @see https://github.com/w3c/webdriver-bidi/blob/master/index.bs
 */
import * as z from 'zod';
import { EmptyResultSchema } from './webdriver-bidi.js';
export var DigitalCredentials;
(function (DigitalCredentials) {
    DigitalCredentials.VirtualWalletActionSchema = z.lazy(() => z.enum(['decline', 'respond', 'wait', 'clear']));
})(DigitalCredentials || (DigitalCredentials = {}));
(function (DigitalCredentials) {
    DigitalCredentials.SetVirtualWalletBehaviorParametersSchema = z.lazy(() => z.object({
        action: DigitalCredentials.VirtualWalletActionSchema,
        context: z.string().optional(),
        protocol: z.string().optional(),
        response: z.record(z.string(), z.any()).optional(),
    }));
})(DigitalCredentials || (DigitalCredentials = {}));
(function (DigitalCredentials) {
    DigitalCredentials.SetVirtualWalletBehaviorSchema = z.lazy(() => z.object({
        method: z.literal('digitalCredentials.setVirtualWalletBehavior'),
        params: DigitalCredentials.SetVirtualWalletBehaviorParametersSchema,
    }));
})(DigitalCredentials || (DigitalCredentials = {}));
(function (DigitalCredentials) {
    DigitalCredentials.SetVirtualWalletBehaviorResultSchema = z.lazy(() => EmptyResultSchema);
})(DigitalCredentials || (DigitalCredentials = {}));
//# sourceMappingURL=webdriver-bidi-digital-credentials.js.map